/* Modded Moto Co - Cart drawer enhancements: reservation timer, Shipping
 * Protection toggle (dynamic tier), discount code field. */
(function () {
  'use strict';
  if (window.__mmcCartEnhance) return;
  window.__mmcCartEnhance = true;

  var PROTECT_HANDLE = 'shipping-protection-1';
  var TIMER_MIN = 10;

  var TIERS = [
    { max: 7500,     id: 46494932172950, price: 400 },
    { max: 15000,    id: 46494932205718, price: 600 },
    { max: 25000,    id: 46494932238486, price: 900 },
    { max: 40000,    id: 46494932271254, price: 1300 },
    { max: 60000,    id: 46494932304022, price: 1800 },
    { max: 80000,    id: 46494932336790, price: 2400 },
    { max: 100000,   id: 46494932369558, price: 3000 },
    { max: 150000,   id: 46494932402326, price: 4000 },
    { max: 200000,   id: 46494932435094, price: 5000 },
    { max: 250000,   id: 46494932467862, price: 5800 },
    { max: 300000,   id: 46494932500630, price: 6500 },
    { max: 350000,   id: 46494932533398, price: 7000 },
    { max: Infinity, id: 46494932566166, price: 7500 }
  ];
  var ALL_IDS = TIERS.map(function (t) { return t.id; });

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function tierFor(cents) {
    for (var i = 0; i < TIERS.length; i++) { if (cents <= TIERS[i].max) return TIERS[i]; }
    return TIERS[TIERS.length - 1];
  }
  function isProtect(item) {
    return item.handle === PROTECT_HANDLE || ALL_IDS.indexOf(item.variant_id) !== -1;
  }
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function baseSubtotal(cart) {
    var total = 0;
    cart.items.forEach(function (it) { if (isProtect(it)) return; total += (it.final_line_price != null ? it.final_line_price : it.line_price); });
    return total;
  }
  function protectLine(cart) {
    for (var i = 0; i < cart.items.length; i++) { if (isProtect(cart.items[i])) return cart.items[i]; }
    return null;
  }
  function hasRealItems(cart) { return cart.items.some(function (it) { return !isProtect(it); }); }
  function wantsProtection() { var v = sessionStorage.getItem('mmc_protect'); return v === null ? true : v === '1'; }
  function setWants(on) { sessionStorage.setItem('mmc_protect', on ? '1' : '0'); }
  function addItem(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) });
  }
  function changeById(id, qty) {
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: String(id), quantity: qty }) });
  }
  function refreshTheme() { document.dispatchEvent(new CustomEvent('cart:refresh')); }

  var busy = false;
  function syncProtection() {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var line = protectLine(cart);
      var done = function () { busy = false; refreshTheme(); };
      if (!hasRealItems(cart)) { if (line) return changeById(line.variant_id, 0).then(done); busy = false; return; }
      if (!wantsProtection()) { if (line) return changeById(line.variant_id, 0).then(done); busy = false; return; }
      var target = tierFor(baseSubtotal(cart));
      if (!line) return addItem(target.id, 1).then(done);
      if (line.variant_id !== target.id) { return changeById(line.variant_id, 0).then(function () { return addItem(target.id, 1); }).then(done); }
      if (line.quantity !== 1) return changeById(line.variant_id, 1).then(done);
      busy = false;
    }).catch(function (e) { busy = false; if (window.console) console.error('[MMC] protect', e); });
  }

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function drawerForm() { return document.querySelector('form[id^="cartForm-"]'); }

  function buildTimer() {
    return el('div', 'mmc-timer', '<span class="mmc-timer-dot"></span><span class="mmc-timer-txt">Your items are reserved for </span><span class="mmc-timer-clock">10:00</span>');
  }
  function buildProtect() {
    var w = el('div', 'mmc-protect', '<div class="mmc-protect-row"><div class="mmc-protect-ico" aria-hidden="true"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg></div><div class="mmc-protect-copy"><div class="mmc-protect-title">Shipping Protection <span class="mmc-protect-price"></span></div><div class="mmc-protect-sub">Protect your order from loss, damage, or theft in transit.</div></div><button type="button" class="mmc-toggle mmc-on" role="switch" aria-checked="true" aria-label="Toggle shipping protection"><span class="mmc-toggle-knob"></span></button></div>');
    w.querySelector('.mmc-toggle').addEventListener('click', function () { setWants(!wantsProtection()); updateProtectUI(); syncProtection(); });
    return w;
  }
  function updateProtectUI() {
    var t = document.querySelector('.mmc-toggle');
    if (!t) return;
    var on = wantsProtection();
    t.setAttribute('aria-checked', on ? 'true' : 'false');
    t.classList.toggle('mmc-on', on);
  }
  function buildDiscount() {
    var w = el('div', 'mmc-disc', '<div class="mmc-disc-row"><input type="text" class="mmc-disc-input" placeholder="Discount code" autocomplete="off" autocapitalize="characters" spellcheck="false"><button type="button" class="mmc-disc-btn">Apply</button></div><div class="mmc-disc-msg" role="status"></div>');
    var input = w.querySelector('.mmc-disc-input');
    var msg = w.querySelector('.mmc-disc-msg');
    function apply() {
      var code = (input.value || '').trim();
      if (!code) return;
      msg.textContent = 'Applying...'; msg.className = 'mmc-disc-msg';
      fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' }).then(function () { return getCart(); }).then(function (cart) {
        var applied = (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) || cart.total_discount > 0;
        if (applied) { msg.textContent = 'Code applied!'; msg.className = 'mmc-disc-msg mmc-ok'; }
        else { msg.textContent = 'Saved - applied at checkout.'; msg.className = 'mmc-disc-msg'; }
        refreshTheme();
      }).catch(function () { msg.textContent = 'Could not apply that code.'; msg.className = 'mmc-disc-msg mmc-err'; });
    }
    w.querySelector('.mmc-disc-btn').addEventListener('click', apply);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
    return w;
  }
  function ensureUI() {
    var form = drawerForm();
    if (!form) return;
    if (false) { /* reservation timer removed */
      var header = form.querySelector('[class*="cart-drawer-header"]');
      var timer = buildTimer();
      if (header && header.parentNode === form) header.insertAdjacentElement('afterend', timer);
      else form.insertBefore(timer, form.firstChild);
    }
    var sub = document.getElementById('cart-drawer-live-region-subtotal');
    if (sub) {
      if (!form.querySelector('.mmc-protect')) sub.parentNode.insertBefore(buildProtect(), sub);
      if (!form.querySelector('.mmc-disc')) sub.parentNode.insertBefore(buildDiscount(), sub);
    }
    form.querySelectorAll('[data-item-key]').forEach(function (c) { if (c.querySelector('a[href*="shipping-protection"]')) c.style.display = 'none'; });
  }
  function refreshUI() {
    ensureUI();
    return getCart().then(function (cart) {
      var real = hasRealItems(cart);
      ['.mmc-protect', '.mmc-disc', '.mmc-timer'].forEach(function (sel) { var n = document.querySelector(sel); if (n) n.classList.toggle('mmc-hidden', !real); });
      var priceEl = document.querySelector('.mmc-protect-price');
      if (priceEl) priceEl.textContent = money(tierFor(baseSubtotal(cart)).price);
      updateProtectUI();
    });
  }
  function timerEnd() {
    var v = parseInt(sessionStorage.getItem('mmc_timer_end') || '0', 10);
    var now = Date.now();
    if (!v || v <= now) { v = now + TIMER_MIN * 60000; sessionStorage.setItem('mmc_timer_end', String(v)); }
    return v;
  }
  function tickTimer() {
    var clocks = document.querySelectorAll('.mmc-timer-clock');
    if (!clocks.length) return;
    var rem = Math.max(0, Math.round((timerEnd() - Date.now()) / 1000));
    if (rem <= 0) { sessionStorage.removeItem('mmc_timer_end'); rem = Math.round((timerEnd() - Date.now()) / 1000); }
    var m = Math.floor(rem / 60), s = rem % 60;
    var txt = m + ':' + (s < 10 ? '0' + s : s);
    clocks.forEach(function (c) { c.textContent = txt; });
  }
  function injectStyles() {
    if (document.getElementById('mmc-cart-style')) return;
    var css =
      '.mmc-hidden{display:none !important;}' +
      '.mmc-timer{display:flex;align-items:center;justify-content:center;gap:8px;margin:0;padding:11px 16px;background:#1b1919;color:#fff;font-size:13px;font-weight:600;letter-spacing:.01em;}' +
      '.mmc-timer-dot{width:8px;height:8px;border-radius:50%;background:#bd40c7;box-shadow:0 0 0 0 rgba(189,64,199,.6);animation:mmcPulse 1.4s infinite;}' +
      '@keyframes mmcPulse{0%{box-shadow:0 0 0 0 rgba(189,64,199,.55)}70%{box-shadow:0 0 0 7px rgba(189,64,199,0)}100%{box-shadow:0 0 0 0 rgba(189,64,199,0)}}' +
      '.mmc-timer-clock{font-variant-numeric:tabular-nums;font-weight:800;color:#fff;min-width:42px;}' +
      '.mmc-protect{margin:12px 16px;padding:14px;border:1px solid rgba(189,64,199,.45);border-radius:12px;background:rgba(189,64,199,.08);}' +
      '.mmc-protect-row{display:flex;align-items:center;gap:12px;}' +
      '.mmc-protect-ico{flex:0 0 auto;color:#e79bef;display:flex;}' +
      '.mmc-protect-copy{flex:1 1 auto;min-width:0;}' +
      '.mmc-protect-title{font-size:14px;font-weight:700;color:#fff;line-height:1.2;}' +
      '.mmc-protect-price{color:#e79bef;font-weight:800;}' +
      '.mmc-protect-sub{font-size:12px;color:#b7b1bd;line-height:1.35;margin-top:2px;}' +
      '.mmc-toggle{flex:0 0 auto;position:relative;width:46px;height:26px;border-radius:999px;border:1px solid rgba(255,255,255,.55);background:#111111;cursor:pointer;transition:background .2s;padding:0;}' +
      '.mmc-toggle .mmc-toggle-knob{position:absolute;top:3px;left:3px;width:20px;height:20px;border-radius:50%;background:#fff;transition:transform .2s;box-shadow:0 1px 3px rgba(0,0,0,.35);}' +
      '.mmc-toggle.mmc-on{background:#bd40c7;}' +
      '.mmc-toggle.mmc-on .mmc-toggle-knob{transform:translateX(20px);}' +
      '.mmc-disc{margin:0 16px 12px;}' +
      '.mmc-disc-row{display:flex;gap:8px;}' +
      '.mmc-disc-input{flex:1 1 auto;min-width:0;padding:10px 12px;border:1px solid rgba(255,255,255,.22);border-radius:9px;font-size:14px;background:rgba(255,255,255,.06);color:#fff;}' +
      '.mmc-disc-input::placeholder{color:#9c96a3;}' +
      '.mmc-disc-input:focus{outline:none;border-color:#bd40c7;box-shadow:0 0 0 3px rgba(189,64,199,.25);}' +
      '.mmc-disc-btn{flex:0 0 auto;padding:10px 18px;border:1.5px solid #bd40c7;border-radius:9px;background:transparent;color:#fff;font-size:13px;font-weight:700;cursor:pointer;transition:background .15s;}' +
      '.mmc-disc-btn:hover{background:rgba(189,64,199,.16);}' +
      '.mmc-disc-msg{font-size:12px;color:#b7b1bd;min-height:0;margin-top:6px;}' +
      '.mmc-disc-msg:empty{margin-top:0;}' +
      '.mmc-disc-msg.mmc-ok{color:#5bd08a;}' +
      '.mmc-disc-msg.mmc-err{color:#ff8a7a;}';
    var s = document.createElement('style');
    s.id = 'mmc-cart-style';
    s.textContent = css;
    document.head.appendChild(s);
  }
  var pending;
  function schedule() { clearTimeout(pending); pending = setTimeout(function () { syncProtection().then(refreshUI); }, 400); }
  function init() {
    injectStyles();
    setInterval(tickTimer, 1000);
    tickTimer();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) { new MutationObserver(function () { ensureUI(); schedule(); }).observe(drawer, { childList: true, subtree: true }); }
    syncProtection().then(refreshUI);
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('modal-open[target="cart-drawer"], [href="/cart"], .add-to-cart, [name="add"]')) schedule(); }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
